import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=5f91c25b"
import script from "./UserSearch.vue?vue&type=script&lang=ts"
export * from "./UserSearch.vue?vue&type=script&lang=ts"
import style0 from "./UserSearch.vue?vue&type=style&index=0&id=5f91c25b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports